import { isFunction } from './is.js';
/**
 * A function that either returns the value (if it isn't a function)
 * or that runs a function and extracts the value from that function.
 *
 * Borrowed from https://github.com/svecosystem/runed/blob/main/packages/runed/src/lib/utilities/extract/extract.svelte.ts
 * (https://github.com/svecosystem/runed/blob/main/LICENSE)
 */
export function extract(value, defaultValue) {
    if (isFunction(value)) {
        const getter = value;
        const extracted = getter();
        return extracted ?? defaultValue ?? extracted;
    }
    return value ?? defaultValue ?? value;
}
